import { Button, Modal } from "@/shared/ui";
import { ModalProps } from "@/shared/ui/modal/Modal";

export default function CrateCharacterNameRulesModal(props: ModalProps) {
  return (
    <Modal {...props} title="Выбор имени и фамилии" className="w-[25rem]">
      <div className="text-15 font-medium text-white/50">
        Придумайте уникальное Имя и Фамилию для вашего персонажа. Используйте только буквы русского
        алфавита. Чтобы более подробно узнать ограничения на используемые имена, разрешённые
        правилами сервера прочитайте информационный блок по ссылке ниже
      </div>
      <Button className="h-[2.75rem] mt-5 w-full" onClick={() => props?.onClose()}>
        ВСЕ ПОНЯТНО
      </Button>
    </Modal>
  );
}
